// {OPERATE_COMPONENT_TYPE}
import * as OC from './operateComponent'

export {OC}